import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    title: {
      type: String,
      default: "Imagem de capa",
    },
    proportion: {
      type: String | null,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["imageFileUrl"]),
    getUrlImage() {
      if (Object.hasOwn(this.imageFileUrl, "name")) {
        return this.imageFileUrl.url;
      }

      const url = this.imageFileUrl?.url || this.imageFileUrl;
      return `data:image/jpg;base64,${url}`;
    },
  },
  watch: {
    imageFileUrl: {
      handler(newValue) {
        if (newValue) {
          this.convertToImageFile(newValue);
        }
      },
      // immediate: true
    },
  },
  methods: {
    ...mapActions(["setImageFileUrl"]),
    previewImage(file) {
      if (!file) return;

      const allowedTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/webp",
      ];
      const messageDefault =
        "Tipo de arquivo inválido. Por favor, envie uma imagem (.jpg, .jpeg, .png ou .webp).";

      if (!allowedTypes.includes(file.type)) {
        this.$swal.fire({
          icon: "error",
          html: messageDefault,
        });
        this.clearInputFile();
        return;
      }

      const reader = new FileReader();
      const fileName = file.name;

      // Define a callback function to run, when FileReader finishes its job
      reader.onload = (e) => {
        const result = e.target.result;
        const objFile = { name: fileName, url: result };
        this.setImageFileUrl(objFile);
      };
      // Start the reader job - read file as a data url (base64 format)
      reader.readAsDataURL(file);
    },
    async convertToImageFile(objFile) {
      const fileUrl = objFile?.url;
      if (!fileUrl) {
        this.clearInputFile();
        return;
      }

      const urlBase64 = "data:image/jpg;base64";
      const url = this.imageFileUrl.isFileBase64
        ? `${urlBase64},${fileUrl}`
        : fileUrl;
      const response = await fetch(url);
      const blob = await response.blob();
      const obj = { name: objFile.name || "nome-arquivo-post.jpg", url: blob };

      if (this.imageFileUrl.isFileBase64) {
        blob.name = obj.name;
        this.previewImage(blob);
        return;
      }

      this.$emit("changePicture", obj);
    },
    clearInputFile() {
      this.$refs.fileuploadimage.value = null;
      this.setImageFileUrl(null);
      this.$emit("changePicture", null);
    },
  },
};
